export default __webpack_public_path__ + "fd18e1a5d7b3be48168e0198a0b64769.png";